/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Watch_Out_ForInputs */

const en_directory_detail_watch_out_for = /** @type {(inputs: Directory_Detail_Watch_Out_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch out for`)
};

const zh_directory_detail_watch_out_for = /** @type {(inputs: Directory_Detail_Watch_Out_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意`)
};

/**
* | output |
* | --- |
* | "Watch out for" |
*
* @param {Directory_Detail_Watch_Out_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_watch_out_for = /** @type {((inputs?: Directory_Detail_Watch_Out_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Watch_Out_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_watch_out_for(inputs)
	return zh_directory_detail_watch_out_for(inputs)
});
export { directory_detail_watch_out_for as "directory.detail.watch_out_for" }